export default __webpack_public_path__ + "images/1749d8b0-anonim.png";